import { render, staticRenderFns } from "./vipRight.vue?vue&type=template&id=139356d1&scoped=true&"
import script from "./vipRight.vue?vue&type=script&lang=js&"
export * from "./vipRight.vue?vue&type=script&lang=js&"
import style0 from "./vipRight.vue?vue&type=style&index=0&id=139356d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139356d1",
  null
  
)

export default component.exports